import {DataSource} from "@/datasources/consulte-grid";
import {BibEmprestimoModel} from '@/models/biblioteca/bibemprestimo/bibemprestimo.model';
import BibEmprestimoService from "@/services/biblioteca/bibemprestimo/bibemprestimo.service";

export default class BibEmprestimoDataSource extends DataSource<BibEmprestimoModel> {
 bibTipoUsuarioId: number;
 segUsuarioId: number;
 gesEscolaId: number;

 constructor(
  pageNumber: number,
  rowsPerPage: number,
  rowsPageCount: number,
  totalRowCount: number,
  Rows: BibEmprestimoModel[],
  bibTipoUsuarioId: number,
  segUsuarioId: number,
  gesEscolaId: number,
  onLoad?: (rows: any) => void
 ) {
  super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<BibEmprestimoModel>())
  this.bibTipoUsuarioId = bibTipoUsuarioId;
  this.segUsuarioId = segUsuarioId;
  this.gesEscolaId = gesEscolaId;
  if (onLoad)
   this.setOnLoad(onLoad);
 }

 async load() : Promise<any> {
  const result = ((await BibEmprestimoService.dadosIndexPaginado(
   this.pageNumber,
   this.rowsPerPage,
   this.filters,
   this.bibTipoUsuarioId,
   this.segUsuarioId,
   this.gesEscolaId
  )).data as any) as DataSource<BibEmprestimoModel>;
  this.pageNumber = result.pageNumber;
  this.rowsPageCount = result.rowsPageCount;
  this.rowsPerPage = result.rowsPerPage;
  this.rows = result.rows;
  this.sortDataField = result.sortDataField;
  this.sortOrder = result.sortOrder;
  this.totalRowCount = result.totalRowCount;
  this.filters = result.filters;
  return super.load();
 }
}
